<div class="appContainer">
    <div class="nft-main ">
        <div class="banner-home">
        <div class="container">
    <div class="row">
        <div class="col-md-12">
          
            <div class="banner-txt1">
                <h3>Muzella – The open NFT Marketplace on GDCC.</h3>
                <p>The first NFT marketplace that enables creators to choose and mint NFTs. Creators know what they are selling, 
                    collectors know what they are buying. Join the revolution with GDCC Network.</p>
            </div>

            <ul class="banner_lists text-center">
                <li>
                
                    <a href="javascript:void(0)" routerLink="/marketplace">Explore</a>
                    <a href="javascript:void(0)" (click)="openCreate()">Create</a>
                </li>
                </ul>



        </div>

        <div class="col-md-12">
        <div class="image">
            <img src="../../../assets/images/1.jpg" class="img-fluid">
        
        </div>
      </div>

    </div>




    </div>
</div>


        <div class="nft-sell mt-200">
            <div class="nft-sell-head">
                <div class="container">
                    <h2>Muzella allows Public and Private NFT Listing.</h2>
                    <p>GDCC Allows creators to make their listed NFT’S on sale visible to public or only  privately. 
                        Trade NFT’S from top GDCC Projects exclusively in their Tokens.
                        </p>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="nft-sell-blocks">
                            <div class="nft-sell-image">
                                <img src="assets/images/ic1.png">
                            </div>

                            <h4>Set up your Wallet</h4>
                            <p>Once you’ve set up your wallet of choice, connect it to Muzella by clicking 
                                the wallet icon in the top right corner.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="nft-sell-blocks">
                            <div class="nft-sell-image">
                                <img src="assets/images/ic2.png">
                            </div>

                            <h4>Add your NFTs</h4>
                            <p>Upload your work (image, video, audio, or 3D art), add a title and description, and customize 
                                your NFTs with properties, stats, and unlockable content.</p>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="nft-sell-blocks">
                            <div class="nft-sell-image">
                                <img src="assets/images/ic3.png">
                            </div>

                            <h4>List them for sale</h4>
                            <p>Choose between auctions, fixed-price listings, and declining-price listings. 
                                You choose how you want to sell your NFTs, and we help you sell them!</p>
                        </div>
                    </div>



                </div>
            </div>
        </div>


        <div class="nft-trending" *ngIf="collections.length>0">
            <div class="nft-trending-head">
                <div class="container">
                    <h2>Trending</h2>
                    <ul class="top_tabs">
                        <li [ngClass]="{'active':collectionMenu == ''}" (click)="showItemByCollection('')"><a
                                href="javascript:void(0)">All items</a></li>
                        <li *ngFor="let item of collections" [ngClass]="{'active':item._id == collectionMenu}"
                            (click)="showItemByCollection(item._id)"><a href="javascript:void(0)">{{item.name}}</a></li>
                    </ul>
                </div>
            </div>
            <div class="nft-trending_body">
                <div class="container">
                    <app-itemskeleton *ngIf="loading"></app-itemskeleton>
                    <div class="row" *ngIf="!loading && collectionItems.length>0">
                        <div class="col-md-3" *ngFor="let item of collectionItems">
                            <app-item [isUserIP]="isUser" [item]="item" (itemEvent)="itemEvent($event)"> </app-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="nft-category">
            <div class="nft-category-head mb-50">
                <div class="container">
                    <h2>Browse By Category</h2>
                    <p>GDCC Allows creators to make their listed NFT’S on sale visible to public or only privately.</p>
                </div>
            </div>
            <div class="nft-category-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-lg-3 " *ngFor="let category of categories">
                            <div class="item" [routerLink]="['/marketplace']"
                                [queryParams]="{category_id: category._id}">
                                <div class="nft-category-listing">
                                    <img [src]="mediaBase + '/images/categories/' + category.category_image">
                                    <div class="nft-category-listing-overlay"></div>
                                    <ul class="ntf-category-foot">
                                        <li>
                                            <h4>{{category.title}}</h4>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>


<div class="section__artists mt-100 mb-100">

    <div class="container">

    <div class="row">

        <div class="col-md-6">
            <img src="../../../assets/images/art.png" class="img-fluid">
        </div>

<div class="col-md-6">
    <div class="section_head flx">
        <h2 class="section__title">Explore our TOP NFT artworks</h2>

        <p>Muzella is the world's first and largest NFT marketplace.
            You can list your own NFTs for sale on the Muzella, and 
            you can browse existing listings. Today, we’re proud to remain the 
            largest general marketplace for user-owned digital items, 
            supporting multiple blockchains, with the broadest set of 
            categories and the best prices for new emerging digital item classes.</p>
    </div>
</div>


        </div>
        </div>
</div>



<div class="section__artists mt-100 mb-50">
    <div class="container">

        <div class="section_head">
            <h2 class="section__title">Top Sellers</h2>
        </div>


        <div class="row mt-50">
            <div class="col-md-6 col-lg-3">
                <div class="creator_item creator_card rounded_border space-x-10">

            <div class="tp_img">
                <img src="../../../assets/images/h-2.png" class="img-fluid">
            </div>

                    <div class="avatars space-x-10">
                        <div class="media">
                            <a routerLink="/">
                                <img src="../../../assets/images/avatar_1.png" alt="Avatar" class="avatar avatar-md" />
                            </a>
                        </div>

                        <div class="ml-3">
                            <a routerLink="/">
                                <p class="avatars_name color_black">@xander_hall...</p>
                            </a>
                            <span class="price color_green">16.58 GDCC</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="creator_item creator_card rounded_border space-x-10">

                    <div class="tp_img">
                        <img src="../../../assets/images/h-2.png" class="img-fluid">
                    </div>
                    <div class="avatars space-x-10">
                        <div class="media">
                            <a routerLink="/">
                                <img src="../../../assets/images/avatar_2.png" alt="Avatar" class="avatar avatar-md" />
                            </a>
                        </div>

                        <div class="ml-3">
                            <a routerLink="/">
                                <p class="avatars_name color_black">@xander_hall...</p>
                            </a>
                            <span class="price color_green">16.58 GDCC</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="creator_item creator_card rounded_border space-x-10">

                    <div class="tp_img">
                        <img src="../../../assets/images/h-3.png" class="img-fluid">
                    </div>

                    <div class="avatars space-x-10">
                        <div class="media">
                            <a routerLink="/">
                                <img src="../../../assets/images/avatar_3.png" alt="Avatar" class="avatar avatar-md" />
                            </a>
                        </div>

                        <div class="ml-3">
                            <a routerLink="/">
                                <p class="avatars_name color_black">@xander_hall...</p>
                            </a>
                            <span class="price color_green">16.58 GDCC</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="creator_item creator_card rounded_border space-x-10">


                    <div class="tp_img">
                        <img src="../../../assets/images/h-1.jpg" class="img-fluid">
                    </div>

                    <div class="avatars space-x-10">
                        <div class="media">
                            <a routerLink="/">
                                <img src="../../../assets/images/avatar_4.png" alt="Avatar" class="avatar avatar-md" />
                            </a>
                        </div>

                        <div class="ml-3">
                            <a routerLink="/">
                                <p class="avatars_name color_black">@xander_hall...</p>
                            </a>
                            <span class="price color_green">16.58 GDCC</span>
                        </div>
                    </div>
                </div>
            </div>

        </div> 


    </div>
</div>